module.exports = __webpack_public_path__ + "img/gift4-01-c04-k1.5a57f8a9.png";